import { render, staticRenderFns } from "./ScanResults.vue?vue&type=template&id=74f50131&"
import script from "./ScanResults.vue?vue&type=script&lang=js&"
export * from "./ScanResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports